export default "__VITE_ASSET__838c5906__"